export default __webpack_public_path__ + "static/media/Ding-Idea.e7ee2dca.mp3";